module.exports = __webpack_public_path__ + "static/media/ic_table_down_caret.5fb64f01.svg";